export default "__VITE_ASSET__usJGVsx0__"